module.exports = __webpack_public_path__ + "media/sound_fight.583a4185.wav";